/**
 * A parte da trilha do visitante que não é componente: as chaves e o parser.
 *
 * Mora fora do VisitorTrack.jsx para poder ser importada por teste sem arrastar
 * React junto.
 *
 * STORAGE_KEY não é lido nem escrito por esta build (ver a nota em
 * ../context/VisitorTrack.jsx — /dev não guarda a escolha entre visitas).
 * Continua definida e testada aqui só porque é a mesma chave que a LP do Nuxt
 * em produção usa em composables/useVisitorTrack.ts — as duas páginas dividem
 * origem, e é o valor que documenta essa coincidência caso o comportamento
 * volte a ser "lembrar" no futuro.
 */

export const STORAGE_KEY = 'ap_visitor_track'
/** Aceito na URL para campanha e compartilhamento: ?perfil=cliente. */
export const QUERY_KEY = 'perfil'

export const FROM_QUERY = {
  cliente: 'client',
  client: 'client',
  parceiro: 'partner',
  externo: 'partner',
  partner: 'partner',
  todos: null,
  ambos: null,
}

/**
 * Lê um valor de URL/localStorage. `undefined` = não reconhecido (o portão
 * abre); `null` = escolha explícita de ver as duas trilhas.
 */
export function parseVisitorTrack(raw) {
  if (raw == null) return undefined
  const key = String(raw).trim().toLowerCase()
  return key in FROM_QUERY ? FROM_QUERY[key] : undefined
}
